import { NavLink } from "react-router-dom";

export const UserMenu = ({ user, brand }) => {
  const initials = (user?.name || user?.email || "U")
    .split(" ")
    .map((s) => s[0])
    .slice(0, 2)
    .join("")
    .toUpperCase();

  return (
    <div className="flex items-center gap-3" data-testid="user-menu">
      <div className="hidden sm:block text-right leading-tight">
        <div className="text-sm font-semibold">{user?.name}</div>
        <div
          className="text-[10px] uppercase tracking-[0.18em] mt-0.5 font-semibold"
          style={{ color: brand.accent_color }}
        >
          {user?.role}
        </div>
      </div>
      <NavLink
        to="/profile"
        data-testid="nav-profile"
        title="Edit your profile"
        className="avatar-ring w-9 h-9 rounded-full bg-[#242c3d] flex items-center justify-center font-bold border border-[#2a3447] overflow-hidden shrink-0"
        style={{ color: brand.accent_color }}
      >
        {user?.avatar_url ? (
          <img src={user.avatar_url} alt={user.name} className="w-full h-full object-cover" />
        ) : (
          initials
        )}
      </NavLink>
    </div>
  );
};

export default UserMenu;
